import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CustomSpinnerService } from '../services/custom-spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private router: Router, private spinner: CustomSpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let loadSpinner = req.body ? (req.body.hideSpinner ? false : true) : true;
    
    // Evaluate if we should show the spinner for this request
    // we are showing the loader only for main api page apis.
    // Header opt-out (X-Hide-Loader: 'true') works for GET requests too, where
    // body.hideLoader can't be used.
    const headerOptOut = req.headers.get('X-Hide-Loader') === 'true';
    const shouldShowSpinner = req.url.indexOf('/upload/file') <= -1 &&
                              !req.body?.hideLoader &&
                              !headerOptOut &&
                              req.url.indexOf('notification/list') <= -1 &&
                              req.url.indexOf('/task/list?reminders') <= -1 &&
                              req.url.indexOf('getReasonTypeList') <= -1 &&
                              loadSpinner;

    if (shouldShowSpinner) {
      this.spinner.showHttp(req);
    }

    return next.handle(req)
        .pipe ( tap ({
          next: (evt) => {
            if (evt instanceof HttpResponse) {
              this.spinner.removeActiveRequest(req);
              if(evt.body && evt.body.status == 1) {
                if (evt.body.setting) {
                  if(evt.body.setting.address_format) {
                    localStorage.setItem('address_format', evt.body.setting.address_format);
                  }
                  if(evt.body.setting.phone_number_formate) {
                    localStorage.setItem('phone_number_format', evt.body.setting.phone_number_format);
                  }
                }
              }
            }
          },
          error: () => {
            this.spinner.removeActiveRequest(req);
          }
        }), finalize(() => {
          if (shouldShowSpinner) {
            this.spinner.hideHttp(req, this.router.url, req.url);
          }

          if (this.router.url.startsWith('/auth/create-password')) {
            this.spinner.show();
            setTimeout(() => {
              this.spinner.hide();
            }, 3000);
          }
        })
      );
  }
}

